<template>
  <div class="ibox">
    <div class="ibox-title">
      Consultas agendadas
    </div>

    <div class="ibox-content">
      <table v-if="eventSchedules" class="table table-borderless table-border table-align">
        <thead>
          <tr>
            <th>Data e hora</th>
            <th></th>
            <th>Atualizado por</th>
            <th>Atualizado em</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in eventSchedules" :key="event.id">
            <td :style="{ 'border-left': `5px solid #${event.color}` }" :class="buildClass(event)">
              {{ event.executeIn | datetime }}
            </td>
            <td>
              <div class="form-check form-switch">
                <div v-if="event.enable" class="badge badge-success px-2 py-1">
                  Ativado
                </div>
                <div v-else class="badge badge-danger px-2 py-1">
                  Desativado
                </div>
              </div>
            </td>
            <td>{{ event.updatedBy }}</td>
            <td>{{ event.updatedAt | datetime }}</td>
            <td v-if="event.executedAt"></td>
            <td v-else>
              <div class="btn-group mr-2">
                <button class="btn btn-outline" @click="toggleEvent(event)">{{ event.enable ? 'Desativar' : 'Ativar'
                  }}</button>
                <button v-if="event.nextEvent" class="btn btn-outline" @click="toggleEvent(event, true)">{{ event.enable
                  ? 'Desativar este e os seguintes' : 'Ativar este e os seguintes' }}</button>
              </div>
              <div class="btn-group">
                <button class="btn btn-outline-red" @click="deleteEvent(event)">Excluir</button>
                <button v-if="event.nextEvent" class="btn btn-outline-red" @click="deleteEvent(event, true)">Excluir
                  este e os seguintes</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!eventSchedules.length">
        Nenhuma consulta agendada
      </div>

      <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
        @pagination="pagination" />

    </div>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'

export default {
  components: { Pagination },
  computed: {
    eventSchedules() {
      return this.getModels || []
    }
  },
  created() {
    this.addOrderBy('executeIn', 'asc')

    const date = new Date()
    date.setHours(0, 0, 0)
    this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
    this.$set(this.query, 'periodType', 'execute_in')
    this.$set(this.query, 'appName', this.appName)
    this.asyncTemplateSelect()
  },
  data: () => ({
    nameModel: 'EventSchedule',
  }),
  methods: {
    buildPath() {
      return 'schedules/events'
    },
    buildClass(event) {
      if (event.executedAt)
        return 'line-through'
    },
    find() {
      this.asyncTemplateSelect()
    },
    toggleEvent(event, next) {
      const data = next ? { enable: !event.enable, next: next } : { enable: !event.enable }

      this.openLoad()
      this.axios.put(`schedules/events/${event.id}`, data)
        .then(() => this.asyncTemplateSelect({ pagination: true }))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    deleteEvent(event, next) {
      if (!confirm('Tem certeza?')) return

      const data = next ? { next: next } : {}

      this.openLoad()
      this.axios.delete(`schedules/events/${event.id}`, { params: data })
        .then(() => this.asyncTemplateSelect({ pagination: true }))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    }
  },
  name: 'EventSchedules',
  mixins: [ModelMapper],
  props: ['appName', 'change'],
  watch: {
    change() {
      this.find()
    }
  }
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
